import React, { useState } from 'react';
import EditorDashboardWrapper from '../../../layout/wrapper/EditorDashboardWrapper';
import styles from '../../../styles/pages/user/qcagentdashboard/qc-search-result.module.scss'
import searchImage1 from '../../../public/assets/images/searchresult_banner1.jpg'

import { Box } from '@mui/system';
import { List, ListItem, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SearchIcons from '../../../public/assets/images/search-glass.svg'


const searchResultContent = [
    {
        image: `${searchImage1}`,
        id: "20135",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "green",
        statusText: <>Video Pending Titling <br/>Since January 22, 2023 at 07:56 PM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "6310",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "pending",
        statusText: <>Video Pending Reviewing <br/>Since September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "5045",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "awaiting",
        statusText: <>Video Awaiting Confirmation  <br/>Since September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "5045",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "published",
        statusText: <>Video Pending Publication  <br/>Since September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "5045",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "published",
        statusText: <>Video Published on September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "5045",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "reject",
        statusText: <>Video Rejected on September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "5045",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "flag",
        statusText: <>Video Flagged as Duplicate on September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },
    {
        image: `${searchImage1}`,
        id: "5045",
        date: "September 26, 2019 at 05:45:23 AM UTC",
        name: "John Smith",
        email: "johnsmith@gmail.com",
        acquisitor: "Theodoulke Tadris",
        acquisitordetails: "(Partner)",
        status: "green",
        statusText: <>Metadata Revision Requested <br/>Since September 26, 2019 at 05:45:23 AM UTC.</>,
        currenWorking: false,
    },

]



function QcSearchResult() {
    const [searchResult,searchNoResult] = useState(true);

    return (
        <>
            <EditorDashboardWrapper>
                {
                    searchResult ?
                    <Box className={styles.search_result_wrapper}>
                    
                    <Box className={styles.search_result_outers}>
                        <Box className={styles.searchrslt_name}>
                            <Typography variant='h5' className={styles.result_h5}>Search results for “john smith”</Typography>
                            <Typography variant='caption' className={styles.search_result_number}>4 results</Typography>
                        </Box>
                        <PerfectScrollbar className={styles.searchresultscrolls}>
                            <Box className={styles.search_result_all}>
                                {
                                    searchResultContent.map((item,index)=>(
                                        <Box className={styles.search_result_in} key={index}>
                                            <Box className={styles.main_img}>
                                                <img src={item?.image} alt=''/>
                                            </Box>
                                            <Box className={styles.search_result_in_rttt}>
                                                <Box className={styles.search_details_list}>
                                                    <List>
                                                        <ListItem>
                                                            <Box className={styles.search_inner_boxes}>
                                                                <strong>VSID:</strong>
                                                                {item?.id}
                                                            </Box>
                                                        </ListItem>

                                                        <ListItem>
                                                            <Box className={styles.search_inner_boxes}>
                                                                <strong>Submission Date:</strong>
                                                                {item?.date}
                                                            </Box>
                                                        </ListItem>

                                                        <ListItem>
                                                            <Box className={`${styles.search_inner_boxes} ${styles.submitter}`}>
                                                                <strong>Submitter Name:</strong>
                                                                {item?.name}
                                                            </Box>
                                                        </ListItem>

                                                        <ListItem>
                                                            <Box className={styles.search_inner_boxes}>
                                                                <strong>Email Address:</strong>
                                                                <Link to={`mailto: ${item?.email}`}>{item?.email}</Link>
                                                            </Box>
                                                        </ListItem>

                                                        <ListItem>
                                                            <Box className={styles.search_inner_boxes}>
                                                                <strong>Acquisitor:</strong>
                                                                {item?.acquisitor}
                                                                <Typography variant='caption' className={styles.details_aqstr}>{item?.acquisitordetails}</Typography>
                                                            </Box>
                                                        </ListItem>
                                                    </List>
                                                </Box>

                                                <Box className={
                                                    item?.status==="green" ? `${styles.green} ${styles.updateStatusTrack}` 
                                                    : 
                                                    item?.status==="pending" ? `${styles.pending} ${styles.updateStatusTrack}` 
                                                    : 
                                                    item?.status==="awaiting" ? `${styles.awaiting} ${styles.updateStatusTrack}` 
                                                    :
                                                    item?.status==="published" ? `${styles.published} ${styles.updateStatusTrack}` 
                                                    :
                                                    item?.status==="reject" ? `${styles.reject} ${styles.updateStatusTrack}` 
                                                    :
                                                    item?.status==="flag" ? `${styles.flag} ${styles.updateStatusTrack}` 
                                                    :
                                                    `${styles.updateStatusTrack}`
                                                }>
                                                    {item?.statusText}
                                                </Box>
                                            </Box>
                                            {
                                                item?.currenWorking ?
                                                <Box className={styles.current_work_process}>
                                                    <Typography variant='body1'>Another colleague is currently working on this video.</Typography>
                                                </Box>
                                                :
                                                ""
                                            }
                                        </Box>
                                    ))
                                }
                            </Box>
                        </PerfectScrollbar>


                    </Box>
                    
                    </Box>
                    :
                    <Box className={`${styles.search_result_wrapper} ${styles.noresult}`}>
                        <Box className={styles.search_result_outers}>
                            <i className={styles.icon_sec}><img src={SearchIcons} alt=''/></i>
                            <Typography variant='body1'>We couldn’t find any matching videos for <strong>john smith.</strong></Typography>
                        </Box>
                    </Box>
                }
                
            </EditorDashboardWrapper>
        </>
    );
}

export default QcSearchResult;